"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _formik = require("formik");

var _iconsMaterial = require("@mui/icons-material");

var _ChuiContext = require("../../Hooks/ChuiContext");

var _LanguageSelectDialog = _interopRequireDefault(require("../DialogBox/LanguageSelectDialog.js"));

var _microsoftCognitiveservicesSpeechSdk = require("microsoft-cognitiveservices-speech-sdk");

var _excluded = ["id", "name", "horizonal"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SpeechSdk = require("microsoft-cognitiveservices-speech-sdk");

var TextBoxAssistantButtonGroup = function TextBoxAssistantButtonGroup(_ref) {
  var id = _ref.id,
      name = _ref.name,
      horizonal = _ref.horizonal,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formik = (0, _formik.useFormikContext)();

  var _useCHUILanguageConte = (0, _ChuiContext.useCHUILanguageContext)(),
      selectedLanguage = _useCHUILanguageConte.selectedLanguage,
      setSelectedLanguage = _useCHUILanguageConte.setSelectedLanguage;

  var _useCHUIAbrLanguageCo = (0, _ChuiContext.useCHUIAbrLanguageContext)(),
      selectedAbrLanguage = _useCHUIAbrLanguageCo.selectedAbrLanguage,
      setSelectedAbrLanguage = _useCHUIAbrLanguageCo.setSelectedAbrLanguage;

  var _useCHUIAbrRegionCont = (0, _ChuiContext.useCHUIAbrRegionContext)(),
      selectedAbrRegion = _useCHUIAbrRegionCont.selectedAbrRegion,
      setSelectedAbrRegion = _useCHUIAbrRegionCont.setSelectedAbrRegion;

  var _useCHUILanguageSuppo = (0, _ChuiContext.useCHUILanguageSupportContext)(),
      languageSupport = _useCHUILanguageSuppo.languageSupport,
      setLanguageSupport = _useCHUILanguageSuppo.setLanguageSupport;

  var _useCHUIOldAbrLanguag = (0, _ChuiContext.useCHUIOldAbrLanguageContext)(),
      selectedOldAbrLanguage = _useCHUIOldAbrLanguag.selectedOldAbrLanguage,
      setSelectedOldAbrLanguage = _useCHUIOldAbrLanguag.setSelectedOldAbrLanguage;

  var _useCHUIUserSelectedL = (0, _ChuiContext.useCHUIUserSelectedLanguageContext)(),
      userSelectedLanguage = _useCHUIUserSelectedL.userSelectedLanguage,
      setUserSelectedLanguage = _useCHUIUserSelectedL.setUserSelectedLanguage;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      speechToTextActive = _useState2[0],
      setSpeechToTextActive = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      textToSpeechActive = _useState4[0],
      setTextToSpeechActive = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openLanguageSelect = _useState6[0],
      setOpenLanguageSelect = _useState6[1];

  var handleSpeechToTextClick = function handleSpeechToTextClick() {
    if (userSelectedLanguage === false) {
      setOpenLanguageSelect(true);
    } else if (!languageSupport["s2t"] || languageSupport["s2t"] === null) {
      alert("Your selected language does not support speech to text");
    } else {
      var speechConfig = SpeechSdk.SpeechConfig.fromSubscription(process.env.REACT_APP_SPEECH_KEY, "westeurope");
      speechConfig.speechRecognitionLanguage = selectedAbrRegion;
      var audioConfig = SpeechSdk.AudioConfig.fromDefaultMicrophoneInput();
      var recognizer = new SpeechSdk.SpeechRecognizer(speechConfig, audioConfig);
      var currentValue = formik.values[name];
      currentValue = currentValue.replace('ERROR: Speech was cancelled or could not be recognized. Ensure your microphone is working properly.', '');
      setSpeechToTextActive(true);

      recognizer.recognizing = function (s, e) {
        formik.setFieldValue(name, currentValue + e.result.text + " ");
      };

      recognizer.recognizeOnceAsync(function (result) {
        setSpeechToTextActive(false);
        var displayText;

        if (result.reason === _microsoftCognitiveservicesSpeechSdk.ResultReason.RecognizedSpeech) {
          displayText = "".concat(result.text, " ");
        } else {
          displayText = 'ERROR: Speech was cancelled or could not be recognized. Ensure your microphone is working properly.';
        }

        formik.setFieldValue(name, currentValue + displayText);
      });
    }
  };

  var handleLanguageSelect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(language, abrLanguage, abrRegion, support) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setOpenLanguageSelect(false);

              if (abrLanguage != selectedAbrLanguage && abrLanguage != null) {
                setSelectedOldAbrLanguage(selectedAbrLanguage);
                setSelectedAbrLanguage(abrLanguage);
                setSelectedLanguage(language);
              }

              setSelectedAbrRegion(abrRegion != null ? abrRegion : selectedAbrRegion);
              setLanguageSupport(support != null ? support : languageSupport);
              setUserSelectedLanguage(true);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLanguageSelect(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleTextToSpeechClick = function handleTextToSpeechClick() {
    if (userSelectedLanguage === false) {
      setOpenLanguageSelect(true);
    } else if (!languageSupport["t2s"] || languageSupport["t2s"] === null) {
      alert("Your selected language does not support text to speech");
    } else {
      setTextToSpeechActive(true);
      var speechConfig = SpeechSdk.SpeechConfig.fromSubscription(process.env.REACT_APP_SPEECH_KEY, "westeurope");
      speechConfig.speechRecognitionLanguage = selectedAbrRegion;
      var audioConfig = SpeechSdk.AudioConfig.fromDefaultSpeakerOutput();
      var textBoxValue = formik.values[name];
      textBoxValue = textBoxValue.replace('ERROR: Speech was cancelled or could not be recognized. Ensure your microphone is working properly.', '');
      var synthesizer = new _microsoftCognitiveservicesSpeechSdk.SpeechSynthesizer(speechConfig, audioConfig);
      synthesizer.speakTextAsync(textBoxValue, function (result) {
        if (result) {
          synthesizer.close();
          setTextToSpeechActive(false);
          return result.audioData;
        }
      }, function (error) {
        console.log(error);
        synthesizer.close();
        setTextToSpeechActive(false);
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 1,
    sm: true,
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true,
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    orientation: horizonal == true ? "horizonal" : "vertical",
    color: "primary",
    sx: {
      maxWidth: "80px"
    }
  }, (languageSupport["t2s"] == true || languageSupport["t2s"] == null) && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Text to speech button",
    color: "secondary",
    size: "medium",
    sx: {
      flex: 1
    },
    onClick: function onClick() {
      handleTextToSpeechClick();
    }
  }, textToSpeechActive == false ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.VolumeUp, null) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.VolumeMute, null)), (languageSupport["s2t"] == true || languageSupport["s2t"] == null) && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    "aria-label": "Speech to text button",
    color: "secondary",
    size: "medium",
    sx: {
      flex: 1
    },
    onClick: function onClick() {
      handleSpeechToTextClick();
    }
  }, speechToTextActive == false ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.Mic, null) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.MicOff, null)))), /*#__PURE__*/_react.default.createElement(_LanguageSelectDialog.default, {
    selectedValue: selectedLanguage,
    open: openLanguageSelect,
    onClose: handleLanguageSelect
  }));
};

var _default = TextBoxAssistantButtonGroup;
exports.default = _default;